<template>
  <v-flex>
    <v-card>
      <v-card-text>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            
        <div class="flex-col-12">

          <div class="flex-row">
            <div class="flex-col-12">
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                Envio de Documentos
              </span>
            </div>
          </div>

          <div class="flex-row">
            <div class="flex-col-12">
              <span style="color: #737a82;font-size: 20px;">
                Estamos quase terminando! A última etapa de preenchimento é o envio de documentos, necessários conforme determinação regulatória.
              </span>
            </div>
          </div>

          <br />
          <br />

          <div class="flex-row">
            <div class="flex-col-6">
              <v-file-input v-model="arquivoAlvaraFuncionamento" chips label="Alvará de Funcionamento *"></v-file-input>
            </div>
                  
            <div class="flex-col-6">
              <v-file-input v-model="arquivoComprovanteQuitacaoISS" chips label="Comprovante de Quitações do ISS *"></v-file-input>
            </div>
          </div>

          <div class="flex-row">
            <div class="flex-col-6">
              <v-file-input v-model="arquivoContratoSocialAlteracoes" chips label="Contrato Social e Alterações *"></v-file-input>
            </div>
                  
            <div class="flex-col-6">
              <v-file-input v-model="arquivoContribSindicalOuDeclaracaoSINCOR" chips label="Contribuição Sindical ou Declaração SINCOR *"></v-file-input>
            </div>
          </div>

          <div class="flex-row">
            <div class="flex-col-6">
              <v-file-input v-model="arquivoRegistroUSEP" chips label="Registro SUSEP *"></v-file-input>
            </div>
                  
            <div class="flex-col-6">
              <v-file-input v-model="arquivoDadosBancarios" chips label="Dados Bancários"></v-file-input>
            </div>
          </div>

          <div class="flex-row">
            <div class="flex-col-12">
              <v-file-input v-model="arquivoTermoDeferimentoReceitaFederal" chips label="Termo Deferimento Receita Federal *"></v-file-input>
            </div>
          </div>          

        </div>           

      </v-card-text>

      <v-card-actions :style="`background-color: rgba(243, 243, 243, 0.25) !important; border-top: 1px black !important;`">
        <v-btn 
          :style="`background-color:transparent !important; color:#7fbdd2 !important; width: 106px !important;`"
          @click="ativarAba(1)"
        >
          ANTERIOR
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          :style="`background-color:#7fbdd2 !important; width: 106px !important; height: 35px !important; border-radius: 4px !important;`" 
          class="white--text" 
          @click="salvar()"
        >
          SALVAR
        </v-btn>

        <v-btn 
          :style="`background-color:#57b846 !important; width: 106px !important; height: 35px !important; border-radius: 4px !important;`" 
          class="white--text" 
          :disabled="!botaoFinalizarEnabled"
          @click="finalizar()"
        >
          FINALIZAR
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-flex>
</template>


<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex';
import Helpers from "@/utilities/Helpers";

export default {
  mixins: [Helpers],

  name: "CorretorDegustacaoDadosCorretor",

  props: ["ativarAba"],

  data() {
    return {
      arquivoAlvaraFuncionamento: null,
      arquivoComprovanteQuitacaoISS:null,
      arquivoContratoSocialAlteracoes:null,
      arquivoContribSindicalOuDeclaracaoSINCOR: null,
      arquivoRegistroUSEP: null,
      arquivoDadosBancarios: null,
      arquivoTermoDeferimentoReceitaFederal: null,
      search: "",
      anexoTipo: ["pdf", "jpeg", "jpg", "png" , "zip"],
      botaoFinalizarEnabled: false,
      fullLoading: false,
      panel: 0,
    }
  },
  computed: {
  ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
  }, 
  methods: {

    validarArquivo: function(arquivoObjeto, tamanhoMegas){

      if(arquivoObjeto == null){
        return true;
      }
      
      const ext = arquivoObjeto.name.substr(arquivoObjeto.name.lastIndexOf('.') + 1);

      let extensaoValida = false;
      this.anexoTipo.forEach(anexoTemp => {
        if(ext.toLowerCase() == anexoTemp.toLowerCase()){
         extensaoValida = true;
        }
      });

        if(!extensaoValida){
          this.showToast("warning", "Atenção!", "Extensão de arquivo não permitida, apenas " + this.anexoTipo.toString() + " são permitidas.");
          return false;
        }

      let tamanhoByte = tamanhoMegas * 1024000;
      if(arquivoObjeto.size >= tamanhoByte){
          this.showToast("warning", "Atenção!", "O tamanho máximo de anexo permito são 3 megas por documento.");
          return false;
      }

      return true;
    },

salvar(){
  debugger;
      const anexoTamanho = 3;

      if(!this.validarArquivo(this.arquivoAlvaraFuncionamento,anexoTamanho)){
        return false;
      }

      if(!this.validarArquivo(this.arquivoComprovanteQuitacaoISS,anexoTamanho)){
        return false;
      }

      if(!this.validarArquivo(this.arquivoContratoSocialAlteracoes,anexoTamanho)){
        return false;
      }

      if(!this.validarArquivo(this.arquivoContribSindicalOuDeclaracaoSINCOR,anexoTamanho)){
        return false;
      }

      if(!this.validarArquivo(this.arquivoRegistroUSEP,anexoTamanho)){
        return false;
      }

      if(!this.validarArquivo(this.arquivoDadosBancarios,anexoTamanho)){
        return false;
      }

      if(!this.validarArquivo(this.arquivoTermoDeferimentoReceitaFederal,anexoTamanho)){
        return false;
      }

      let codigoCorretor = this.usuario.codCorretor;
      let formData = new FormData();

      formData.append('CodigoCorretor', codigoCorretor);
      formData.append('ArquivoAlvaraFuncionamento', this.arquivoAlvaraFuncionamento);
      formData.append('ArquivoComprovanteQuitacaoISS', this.arquivoComprovanteQuitacaoISS);
      formData.append('ArquivoContratoSocialAlteracoes', this.arquivoContratoSocialAlteracoes);
      formData.append('ArquivoContribSindicalOuDeclaracaoSINCOR', this.arquivoContribSindicalOuDeclaracaoSINCOR);
      formData.append('ArquivoRegistroUSEP', this.arquivoRegistroUSEP);
      formData.append('ArquivoDadosBancarios', this.arquivoDadosBancarios);
      formData.append('ArquivoTermoDeferimentoReceitaFederal', this.arquivoTermoDeferimentoReceitaFederal);

      let url = "CorretorDegustacao/UploadDocumento";
      this.fullLoading = true;
      Vue.prototype.$httpPortal.post(url, formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }
      ).then(res => {
          this.botaoFinalizarEnabled = true;
          this.fullLoading = false;
          console.log(res.data);

          if(res.data.length > 0)
          {
              this.showToast("error", "Erro", res.data);
              return;
          }
          this.showToast("success", "Sucesso", "Documentos enviados com sucesso!");
      })
      .catch(res => {
          this.fullLoading = false;
          this.showToast("error", "Erro", "Falha no envio de documentos");
          console.log(res);
      }); 

      //this.ativarAba(3);
      return;
    },    

    finalizar(){
      let codigoCorretor = this.usuario.codCorretor;

      let url = "CorretorDegustacao/FinalizarCadastro/" + codigoCorretor;

      Vue.prototype.$httpPortal.post(url, codigoCorretor)
        .then(res => {
            console.log(res.data);

            debugger;
            if(!res.data.data.Sucesso)
            {
                this.showToast("error", "Erro", res.data.data.Errors[0]);
                return;
            }
            this.ativarAba(3);
        })
        .catch(res => {
            this.showToast("error", "Erro", "Falha no envio de documentos");
            console.log(res);
        }); 

      return;
    }
  },
  
}
</script>